import { makeStyles } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { GraphFilterButtonType } from "./type";

const GraphFilterButton = ({
  text,
  active,
  onClick,
}: GraphFilterButtonType) => {
  const classes = useStyles(active);
  return (
    <Button className={classes.timeFrameBtn} onClick={onClick}>
      {text}
    </Button>
  );
};

export default GraphFilterButton;

const useStyles = makeStyles((theme) => ({
  timeFrameBtn: {
    background: (active) => (active ? "#fff" : "rgba(15, 8, 36, 0.55)"),
    border: "1px solid rgba(230, 231, 233, 0.1)",
    boxShadow: "inset 0px 23.0177px 33.051px -33px rgba(255, 255, 255, 0.5)",
    borderRadius: "10px",
    color: (active) => (active ? "#090613" : "#fff"),
    marginRight: 12,
    fontSize: "12px",
    lineHeight: "10px",
    fontWeight: 600,
    height: 32,
    padding: "0 18px",

    "&:hover": {
      color: (active) => (active ? "#000" : "#fff"),
      background: (active) => (active ? "#fff" : "rgba(15, 8, 36, 0.55)"),
    },

    [theme.breakpoints.between(960, 1000)]: {
      marginRight: 6,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 7px",
      marginBottom: 5,
      fontSize: "11px",
    },
  },
}));
